import { NgModule } from '@angular/core';
import { Store } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { initializeModule } from './actions/routing-status.actions';
import { BcConfigService } from 'common/config/provider';
import { GenesysCloudRoutingStatusEffects } from './effects/routing-status.effects';

@NgModule({
  imports: [
    EffectsModule.forFeature([
      GenesysCloudRoutingStatusEffects
    ])
  ]
})
export class GenesysCloudRoutingStatusModule {
  constructor(readonly store: Store, readonly configService: BcConfigService) {
    if (configService.isGenesysConversationEnabled()) {
      store.dispatch(initializeModule());
    }
  }
}
